import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext"; // Assuming you store user data in context
import UserStatus from "./UserStatus";

export default function Referral_Dashboard() {
  const { user } = useAuth(); // Get logged-in user from context
  const [referralsCount, setReferralsCount] = useState(0);
  const [rewardsEarned, setRewardsEarned] = useState(0);
  const referralsNeeded = 10;
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
  
  const referralLink = `${window.location.origin}/signup?ref=${user?.referralCode}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      alert("Referral link copied!");
    });
  };

  const shareText = encodeURIComponent(
    `Sign up for free at TradeBarta.com and get instant notifciations through telegram/sms when your desired stock prices are hit. ${referralLink}`
  );

  const shareUrls = {
    telegram: `https://t.me/share/url?text=${encodeURIComponent(shareText)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(referralLink)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${shareText}`,
  };

  const referralsLeft = referralsNeeded - referralsCount > 0 ? referralsNeeded - referralsCount : 0;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("goal") === "achieved") {
      alert("🎉 Congratulations! You've earned a free month!");
    }
  }, []);

  // 🔹 Fetch live stats from API
  useEffect(() => {
    if (!user?.id) return;
    fetch(`${process.env.REACT_APP_API_URL}/api/referral-stats/${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setReferralsCount(data.stats.paid_referrals);
          console.log(data.stats.paid_referrals);
          setRewardsEarned(data.stats.rewards_earned);
        }
      })
      .catch((err) => console.error("Error fetching referral stats:", err));
  }, [user]);

  return (
      <div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>            
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}              
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
              <ul>
                <li><a href="/dashboard">Dashboard</a></li>
                <li><a href="/payment_history">Billing and Payment History</a></li>
                <li><a href="/referral_dashboard">Refer & Win</a></li>
                <li><a href="/profile">My Profile</a></li>
                <li><a href="/contact_us">Support</a></li>
              </ul>
            </aside>
            <main className="main-content">
       <section className="data-table referral-section">
  <h4>Referral Link</h4>

  <div className="referral-link-box">
    <input
      type="text"
      readOnly
      value={referralLink}
      onFocus={(e) => e.target.select()}
      className="referral-input"
    />
    <button onClick={copyToClipboard} className="referral-button">Copy Link</button>
  </div>

        <h6>Share Your Referral Link on Social Media - Telegram, WhatsApp, Facebook etc and earn paid plans as rewards</h6>
 {/* <div className="social-buttons">
    <a href={shareUrls.telegram} target="_blank" rel="noopener noreferrer" className="social-button">Telegram</a>
    <a href={shareUrls.facebook} target="_blank" rel="noopener noreferrer" className="social-button">Facebook</a>
    <a href={shareUrls.linkedin} target="_blank" rel="noopener noreferrer" className="social-button">LinkedIn</a>
    <a href={shareUrls.whatsapp} target="_blank" rel="noopener noreferrer" className="social-button">WhatsApp</a>
  </div>
        */}
</section>

        <section className="data-table">
   <h4>Progress</h4>
        <p>You have referred <strong>{referralsCount}</strong> out of <strong>{referralsNeeded}</strong> friends who signed up for paid plans.</p>
        {referralsLeft > 0 ? (
          <p>Only <strong>{referralsLeft}</strong> more to earn your next free month!</p>
        ) : (
          <p>🎉 You earned a free month! Check your account for rewards.</p>
        )}
      </section>

      <section className="data-table">
        <div style={styles.section}>
        <h4>Rewards Earned</h4>
        <p>You have earned <strong>{rewardsEarned}</strong> free month{rewardsEarned !== 1 ? "s" : ""} of subscription so far.</p>
      </div>
  </section>

  </main>

    </div>
    
      </div>
  );
}

const styles = {
  container: {
    maxWidth: 700,
    margin: "40px auto",
    padding: 20,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#222",
    backgroundColor: "#f9faff",
    borderRadius: 10,
  },
  section: {
    marginBottom: 30,
  },
  linkBox: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  input: {
    flexGrow: 1,
    padding: 10,
    fontSize: 16,
    borderRadius: 5,
    border: "1px solid #ccc",
  },
  button: {
    backgroundColor: "#0a74da",
    color: "white",
    border: "none",
    padding: "10px 16px",
    borderRadius: 5,
    cursor: "pointer",
    fontWeight: "bold",
  },
  socialButtons: {
    display: "flex",
    gap: 15,
    marginTop: 10,
  },
  socialButton: {
    backgroundColor: "#0a74da",
    color: "white",
    padding: "10px 14px",
    borderRadius: 5,
    textDecoration: "none",
    fontWeight: "600",
  },
};
